<template>
    <div class="container">
        <div class="message">{{ message() }}</div>
    </div>
</template>

<script>
export default {
    name: 'error',
    props: {
        error: {
            type: String | Number | Object
        }
    },
    methods: {
        message: function () {
            let err = this.error

            if(typeof err === 'object') {
                if (err.message) {
                    return err.message
                } else if(err.code){
                    err = err.code
                }
            }

            if (typeof err === 'number') {
                switch (err) {
                    case 403:
                        return this.$t('no_permission_for_display');
                }
            } else if (typeof err === 'string') {
                return err
            }

            return this.$t('unknown_error')
        }
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: italic;
    font-size: 24px;
    font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/templates/part/ui/error.vue